import { ProductExtension } from './productExtension.model';

export class ProductImage extends ProductExtension {
    productImageName: string;
    position: number;
}
